import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';

import { convertEpochTime } from 'core/utilities';
import { Icon, Table, ToolTip, IndexTableContextMenu, WinRedChip } from 'modules/common';

export function UpsellPathwayItemsDesktop({ items, navigateToItem, dropdownAction, profileCandidate }) {
  const tableBody = items.map(item => {
    const { revv_uid, name, page_count, created_at, creator, upsell_count, bill_pay_exists } = item;

    const navigateHandler = event => navigateToItem(revv_uid, event);

    return (
      <Table.Row key={revv_uid} onClick={navigateHandler} onKeyPress={navigateHandler} tabIndex="0" role="link">
        <Table.Cell textAlign="center" className="icon-cell">
          <ToolTip tooltip="Upsell Pathway">
            <Icon icon="upsell-pathway-icon" size="sm" />
          </ToolTip>
        </Table.Cell>
        <Table.Cell>{convertEpochTime(created_at)}</Table.Cell>
        <Table.Cell>{name}</Table.Cell>
        <Table.Cell>{creator}</Table.Cell>
        <Table.Cell>
          {bill_pay_exists ? (
            <WinRedChip className="cursor-default" variant="purple">
              Bill-Pay
            </WinRedChip>
          ) : null}
        </Table.Cell>
        <Table.Cell>{upsell_count}</Table.Cell>
        <Table.Cell>{page_count}</Table.Cell>
        <Table.Cell textAlign="center" noClick>
          <IndexTableContextMenu onSelect={(eventKey, event) => dropdownAction(eventKey, item, event)}>
            <Dropdown.Item eventKey="details">View Details</Dropdown.Item>
            <Dropdown.Item eventKey="duplicate">Duplicate</Dropdown.Item>
            <Dropdown.Item eventKey="archive">Archive</Dropdown.Item>
          </IndexTableContextMenu>
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeaderCell className="d-none d-md-table-cell" />
          <Table.HeaderCell>Date Created</Table.HeaderCell>
          <Table.HeaderCell>Upsell Pathway Name</Table.HeaderCell>
          <Table.HeaderCell>Created By</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell>Upsells</Table.HeaderCell>
          <Table.HeaderCell>Attached Pages</Table.HeaderCell>
          <Table.HeaderCell className="d-none d-md-table-cell" />
        </Table.Row>
      </Table.Head>
      <Table.Body className="pointer">{tableBody}</Table.Body>
    </Table>
  );
}

UpsellPathwayItemsDesktop.propTypes = {
  items: PropTypes.array.isRequired,
  navigateToItem: PropTypes.func.isRequired,
  dropdownAction: PropTypes.func.isRequired,
  profileCandidate: PropTypes.object.isRequired,
};
